import LTR from "@brand-icons/global/ui-check-bold/ui-check-bold-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiCheckBoldIcon = iconFactory("UiCheckBoldIcon", LTR);
